import { useState } from 'preact/hooks';

/**
 * Use: assign the "key" to the container you want to re-mount, then trigger forceRemount() any times you need
 * @returns [Number, Function]
 */
export const useForceRemount = () => {
  const [key, setKey] = useState(1);
  const forceRemount = () => setKey((prevKey) => prevKey + 1);
  return [key, forceRemount];
};
